<template>
    <div
        :id="'module-social-' + dModule.id"
        class="module-social text-center"
        :style="socialStyle"
    >
        <div v-for="social in socials" :key="social.type" class="d-inline">
            <a
                v-if="dModule.data[social.type]"
                :href="social.hrefPrefix + dModule.data[social.type]"
            >
                <font-awesome-icon
                    class="mr-2"
                    :icon="[social.iconPrefix, social.icon]"
                    size="2x"
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "SocialsModule",
    props: {
        data: Object,
    },
    data() {
        return {
            dModule: this.data,
            socials: [
                {
                    type: "email",
                    hrefPrefix: "mailto:",
                    iconPrefix: "fas",
                    icon: "envelope",
                },
                {
                    type: "phone",
                    hrefPrefix: "tel:",
                    iconPrefix: "fas",
                    icon: "phone-alt",
                },
                {
                    type: "whatsapp",
                    hrefPrefix: "https://wa.me/",
                    iconPrefix: "fab",
                    icon: "whatsapp",
                },
                {
                    type: "website",
                    hrefPrefix: "",
                    iconPrefix: "fas",
                    icon: "globe",
                },
                {
                    type: "facebook",
                    hrefPrefix: "",
                    iconPrefix: "fab",
                    icon: "facebook",
                },
                {
                    type: "twitter",
                    hrefPrefix: "",
                    iconPrefix: "fab",
                    icon: "twitter",
                },
                {
                    type: "linkedin",
                    hrefPrefix: "",
                    iconPrefix: "fab",
                    icon: "linkedin",
                },
                {
                    type: "instagram",
                    hrefPrefix: "",
                    iconPrefix: "fab",
                    icon: "instagram",
                },
                {
                    type: "youtube",
                    hrefPrefix: "",
                    iconPrefix: "fab",
                    icon: "youtube",
                },
            ],
        };
    },
    computed: {
        socialStyle() {
            return {
                color: this.dModule.layout.iconColor,
            };
        },
    },
};
</script>

<style scoped>
.module-social a {
    color: inherit;
}
</style>
